import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IProductState {
  productInFix: any;
}

const initialState: IProductState = {
  productInFix: null,
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProductInFixing: (state, action: PayloadAction<{ product: any }>) => {
      state.productInFix = action.payload.product;
    }
  },
});

export const { setProductInFixing } = productSlice.actions;

// Avoid importing RootState here to prevent circular type dependencies with the store.
// Use a loosely typed state parameter for selectors.
export const selectProductInFixing = (state: any) => state.product.productInFix;

export default productSlice.reducer;



